import { DateTime } from 'luxon';

/**
 * Format an ISO timestamp into a compact relative string:
 *  - Today:    "14:30"       (HH:mm)
 *  - < 7 days: "2d ago"      (locale-aware short relative)
 *  - Older:    "15/03/25"    (dd/MM/yy)
 */
export function formatRelativeTime(
  isoString: string | null | undefined,
  locale: string = 'en'
): string {
  if (!isoString) return '';
  const dt = DateTime.fromISO(isoString);
  if (!dt.isValid) return '';
  const diffDays = Math.abs(dt.diffNow('days').days);
  if (diffDays < 1) return dt.toFormat('HH:mm');
  if (diffDays < 7) return dt.setLocale(locale).toRelative({ style: 'short' }) || '';
  return dt.toFormat('dd/MM/yy');
}
